import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import {
  SearchFacets,
  SearchFacetRefinementSelect,
  SearchFacetRefinementCheckboxes,
} from '@uncinc/react-searchkit';
import type { SearchFacetsProps } from '@uncinc/react-searchkit/dist/components/Facets';

import { facetAttributes } from '../config';

import './style.scss';

const Facets: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      {facetAttributes.map((facetAttribute) => {
        const attribute = typeof facetAttribute === 'object' ? facetAttribute.attribute : facetAttribute;

        const Facet = (attribute === 'themes_name')
          ? SearchFacetRefinementCheckboxes
          : SearchFacetRefinementSelect;

        return (
          <Facet
            className="Select__inner"
            key={attribute}
            title={t(`searchkit.facets.${attribute}.label`)}
            attribute={attribute}
            placeholder={t(`searchkit.facets.placeholder`)}
          />
        );
      })}
    </>
  );
};

interface SearchAllContentFacetsProps extends SearchFacetsProps {
  dialogEnabled?: boolean;
}

// These facets are also used in the MetaSearch
const SearchAllContentFacets: React.FC<SearchAllContentFacetsProps> = (props) => {
  const {
    className,
    ...restProps
  } = props;

  const classNames = c('SearchAllContent__Facets', className);

  return (
    <SearchFacets {...restProps} className={classNames}>
      <Facets />
    </SearchFacets>
  );
};

export default SearchAllContentFacets;
